/* eslint-disable @typescript-eslint/camelcase */
import {
  CategoryPusatResolusi,
  TicketPusatResolusiDetail,
  TicketDetail,
  TicketData,
  EscalatePartnerData,
  CategoryData,
  AttachmentData,
  SummaryData,
  TicketAction,
  FollowerData,
  TicketCounterPusatResolusi,
  ListTicketPusatResolusi,
  ListTicketData,
  CheckIssuePusatResolusi,
  PusatResolusiSTTData,
  PusatResolusiSTT,
  MentionsData,
  HistoryChatResponse,
  HistoryChatData,
  Conversation,
  ConversationValue,
  ConversationValueMention,
  ConversationValueAttachment
} from "@/domain/entities/PusatResolusiV2";
import { AxiosResponse } from "axios";
import { PaginationV2 } from "@/domain/entities/Pagination";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { formatDateNumber } from "@/app/infrastructures/misc/Utils";

export class PusatResolusiV2Mapper {
  public convertCheckTicketPusatResolusiFromApi(
    res: AxiosResponse<any>
  ): TicketPusatResolusiDetail {
    const {
      data: { data }
    } = res;

    return new TicketPusatResolusiDetail({
      id: data.id,
      caseNumber: data.case_number,
      ticketNo: data.ticket_no,
      refNo: data.ref_no,
      categoryCode: data.category_code,
      categoryName: data.category_name,
      isEligibleCategory: data.is_eligible_category,
      ticketSource: data.ticket_source,
      shipmentLastStatus: data.shipment_last_status,
      sttLastStatus: data.stt_last_status,
      action: data.action,
      status: data.status_ticket,
      success: true
    });
  }

  public convertListCategoryPusatResolusiFromApi(
    res: AxiosResponse<any>
  ): CategoryPusatResolusi[] {
    const {
      data: { data }
    } = res;

    return data?.length
      ? data.map(
          (item: any) =>
            new CategoryPusatResolusi({
              code: item.code,
              type: item.type,
              typeLabel: item.type_label,
              label: item.label,
              template: item.template,
              isEligible: item.is_eligible,
              isDescRequired: item.is_desc_required,
              isAttachmentRequired: item.is_attachment_required
            })
        )
      : [];
  }

  public convertNotificationTicketPusatResolusiFromApi(
    res: AxiosResponse<any>
  ): TicketCounterPusatResolusi {
    const {
      data: { data }
    } = res;

    return new TicketCounterPusatResolusi({
      countTicketNeedToBeSolved: data.count_ticket_need_to_be_solved,
      countNewMessage: data.count_new_message,
      countMention: data.count_mention,
    });
  }

  public convertSTTListFromApi(res: AxiosResponse<any>): PusatResolusiSTTData {
    const { data, meta } = res.data;
    return new PusatResolusiSTTData({
      data: data
        ? data.map((item: any) => {
            return new PusatResolusiSTT({
              sttNo: item.stt_no,
              senderName: item.sender_name,
              originCity: item.origin_city,
              destinationCity: item.destination_city,
              lastStatus: item.last_status
            });
          })
        : [],
      page: meta.page,
      limit: meta.limit,
      totalRecords: meta.total_records
    });
  }
  public convertCheckIssuePusatResolusiFromApi(
    res: AxiosResponse<any>
  ): CheckIssuePusatResolusi {
    const {
      data: { data }
    } = res;

    return new CheckIssuePusatResolusi({
      id: data.id,
      caseNumber: data.case_number,
      refNo: data.ref_no,
      categoryCode: data.category_code,
      categoryName: data.category_name,
      isEligibleCategory: data.is_eligible_category,
      shipmentLastStatus: data.shipment_last_status,
      sttLastStatus: data.stt_last_status,
      statusTicket: data.status_ticket,
      action: data.action
    });
  }

  public convertListTicketPusatResolusiFromApi(
    res: AxiosResponse<any>
  ) {
    const {
      data: { data, meta }
    } = res;

    return new ListTicketPusatResolusi({
      pagination: new PaginationV2({
        allTotalData: meta.total_records,
        page: meta.page,
        limit: meta.limit,
        totalData: meta.total_records
      }),
      data: data.map((item: any) => {
        return new ListTicketData({
          id: item.id,
          issueNo: item.issue_no,
          needToBeSolved: item.need_to_be_solved,
          sttOrShipmentNumber: item.stt_or_shipment_number,
          categoryIssue: item.category_issue,
          ticketPriority: item.ticket_priority,
          statusTicket: item.status_ticket,
          createdAt: item.created_at,
          createdBy: item.created_by,
          unreadMessage: item.unread_message,
          mentioned: item.mentioned,
          eligibleAction: item.eligible_action,
          assignToUsername: item.assign_to_username
        })
      })
    })
  }

  public convertResponseFollowTicketFromApi(
    result: AxiosResponse<any>
  ): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      message: data.message
    });
  }

  public convertResponseSendChatFromApi(
    result: AxiosResponse<any>
  ): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      message: data.message
    });
  }

  public convertTicketDetailFromApi(
    result: AxiosResponse<any>
  ) {
    const {data: {data}} = result;

    const ticket = data.ticket;
    const summary = data.summary;
    const escalatePartnerHistory = ticket.escalate_partner_history || [];
    const escalatePartner = ticket.escalate_partner || [];
    const attachments = ticket.attachments || []
    const followers = ticket.follower || []

    return new TicketDetail({
      ticket: new TicketData({
        updatedAt: ticket.updated_at,
        ticketNo: ticket.ticket_no,
        status: ticket.status,
        refNo: ticket.ref_no,
        priority: ticket.priority,
        note: ticket.note,
        id: ticket.id,
        followers: this._mapFollowersData(followers),
        escalatePartnerHistory: this._mapEscalateData(escalatePartnerHistory),
        escalatePartner: this._mapEscalateData(escalatePartner),
        desc: ticket.desc,
        createdByUsername: ticket.created_by_username,
        createdByTier: ticket.created_by_tier,
        createdByPartnerName: ticket.created_by_partner_name,
        createdByPartnerCode: ticket.created_by_partner_code,
        createdBy: ticket.created_by,
        createdAt: ticket.created_at,
        categoryCode: ticket.category_code,
        category: new CategoryData({
          typeLabel: ticket.category.type_label,
          type: ticket.category.type,
          label: ticket.category.label,
          code: ticket.category.code,
          case: ticket.category.case
        }),
        caseNumber: ticket.case_number,
        attachments: attachments.map((attachment: any) => {
          return new AttachmentData({
            url: attachment.url,
            sizeInKB: attachment.size_in_kb,
            fileName: attachment.file_name,
            ext: attachment.ext
          })
        }),
        agentCsName: ticket.agent_cs_name,
        agentCsId: ticket.agent_cs_id,
        agentCsAt: ticket.agent_cs_at
      }),
      summary: this._mapSummaryData(summary)
    })
  }

  private _mapSummaryData(summary: any) {
    return new SummaryData({
        volumeWeight: summary.volume_weight,
        totalPiece: summary.total_piece,
        totalDexAttempt: summary.total_dex_attempt,
        totalDelAttempt: summary.total_del_attempt,
        totalCodrejattempt: summary.total_codrej_attempt,
        product: summary.product,
        originCity: summary.origin_city,
        lastStatusAt: summary.last_status_at,
        lastStatus: summary.last_status,
        lastDelivStatus: summary.last_deliv_status,
        lastDelivReasonName: summary.last_deliv_reason_name,
        lastDelivReasonCode: summary.last_deliv_reason_code,
        lastDelivPartnerName: summary.last_deliv_partner_name,
        lastDelivPartnerCode: summary.last_deliv_partner_code,
        lastDelivCourierName: summary.last_deliv_courier_name,
        lastDelivAt: summary.last_deliv_at,
        isSla: summary.is_sla,
        isInsurance: summary.is_insurance,
        isDfod: summary.is_dfod,
        isCod: summary.is_cod,
        grossWeight: summary.gross_weight,
        goodsPrice: summary.goods_price,
        estimatedSlaStartDate: summary.estimated_sla_start_date,
        estimatedSlaEndDate: summary.estimated_sla_end_date,
        dimWidth: summary.dim_width,
        dimLength: summary.dim_length,
        dimHeight: summary.dim_height,
        destinationCity: summary.destination_city,
        commodityName: summary.commodity_name,
        commodityIsQuarantine: summary.commodity_is_quarantine,
        commodityIsDg: summary.commodity_is_dg,
        commodityCode: summary.commodity_code,
        codAmount: summary.cod_amount,
        chargeableWeight: summary.chargeable_weight,
        bookedTier: summary.booked_tier,
        bookedName: summary.booked_name,
        bookedAt: summary.booked_at
      })
  }

  private _mapFollowersData(followers: any) {
    return followers.map((foll: any) => {
      return new FollowerData({
        isYou: foll.is_you,
        accountUsername: foll.account_username,
        accountPartnerName: foll.account_partner_name,
        accountPartnerCode: foll.account_partner_code
      })
    })
  }

  private _mapEscalateData(escalate: any) {
    return escalate.map((history: any) => {
      return new EscalatePartnerData({
        isYou: history.is_you,
        escalatePartnerUsername: history.escalate_partner_username,
        escalatePartnerName: history.escalate_partner_name,
        escalatePartnerCode: history.escalate_partner_code,
        escalateAt: history.escalate_at,
        escalateFinish: history.escalate_finish,
        createdAt: history.created_at || ""
      })
    })
  }

  public convertTicketActionFromApi(
    res: AxiosResponse<any>
  ): TicketAction {
    const data: any = res;

    return new TicketAction({
      isOpenMultipleTab: data.data.is_open_multiple_tab || false,
      isAssignedToOther: data.data.is_assigned_to_other || false,
      assignedUsername: data.data.assigned_username || "",
      action: data.data.action || []
    });
  }

  public convertCreateTicketPusatResolusiFromApi(
    res: AxiosResponse<any>
  ): TicketPusatResolusiDetail {
    const {
      data: { data }
    } = res;

    return new TicketPusatResolusiDetail({
      id: data.id,
      ticketNo: data.ticket_no,
      refNo: data.ref_no,
      caseNumber: data.case_number,
      categoryCode: data.category_code,
      categoryName: data.category?.label,
      desc: data.desc,
      status: data.status,
      success: true
    });
  }

  public convertMentionDataFromApi(res: AxiosResponse<any>): MentionsData[] {
    const data: any = res.data;

    return data.data.map((item: any) => {
      return new MentionsData({
        code: item.code,
        name: item.name,
        type: item.type
      });
    });
  }

  public convertHistoryChatResponseFromApi(result: AxiosResponse<any>) {
    const { data } = result;

    const ticket = data.data;
    const conversations = ticket.conversations || [];
    const meta = data.meta || {};

    return new HistoryChatResponse({
      data: new HistoryChatData({
        lastReadId: ticket.last_read_id,
        lastReadAt: ticket.last_read_at,
        firstUnreadMessageAt: ticket.first_unread_message_at,
        unreadCount: ticket.unread_count,
        conversations: this._mapConversationsData(conversations),
      }),
      beforeId: meta.before_id,
      limit: meta.limit,
      totalRecords: meta.total_records
    });
  }

  public convertHistoryChatResponseFromWebsocket(result: string) {
    const parsedResult = JSON.parse(result);

    return this._mapConversationsData([parsedResult]);
  }

  private _mapConversationsData(conversations: any[]) {
    return conversations ? conversations.map((conv: any) => {
      return new Conversation({
        id: conv.id,
        type: conv.type,
        createdBy: conv.created_by,
        createdName: conv.created_name || conv.created_by_name,
        createdByPartnerCode: conv.created_by_partner_code,
        createdByPartnerName: conv.created_by_partner_name,
        createdAt: conv.created_at,
        groupDate: formatDateNumber(conv.created_at),
        time: conv.time,
        isMentioned: conv.is_mentioned,
        isOpenMultipleTab: conv.is_open_multiple_tab,
        isEscalatePartner: conv.is_escalate_partner,
        isAssignedToOther: conv.is_assigned_to_other,
        assignedTo: conv.assigned_to,
        assignedUsername: conv.assigned_username,
        action: conv.action,
        error: conv.error,
        value: this._mapConversationValueData(conv.value),
      });
    }).sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()) : [];
  }

  private _mapConversationValueData(value: any) {
    if (!value) return new ConversationValue();
    return new ConversationValue({
      oldAgent: value.old_agent,
      newAgent: value.new_agent,
      oldPriority: value.old_priority,
      newPriority: value.new_priority,
      status: value.status,
      oldCategory: value.old_category,
      newCategory: value.new_category,
      note: value.note,
      isSolved: value.is_solved,
      message: value.message,
      title: value.title,
      escalatePartnerCode: value.escalate_partner_code,
      escalatePartnerName: value.escalate_partner_name,
      escalateNoteConversationId: value.escalate_note_conversation_id,
      mentions: this._mapConversationValueMentions(value.mentions),
      attachments: this._mapConversationValueAttachments(value.attachments)
    });
  }

  private _mapConversationValueMentions(mentions: any[]) {
    return mentions ? mentions.map((mention: any) => {
      return new ConversationValueMention({
        type: mention.type,
        code: mention.code,
        name: mention.name
      });
    }) : [];
  }

  private _mapConversationValueAttachments(attachments: any[]) {
    return attachments ? attachments.map((attachment: any) => {
      const ext = attachment.name.split('.').pop()
      return new ConversationValueAttachment({
        name: attachment.name,
        url: attachment.url,
        ext: ext,
        sizeInMegabytes: attachment.size_in_megabytes
      });
    }) : [];
  }
}
